<app-loading *ngIf="cargando"></app-loading>
<div *ngIf="!cargando">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate>
    <div class="grid form-group">
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'REQUISITOS.LBL_REQUISITOS' | translate }}</label>
          <p-dropdown disableTab  id="idRespaldo" name="nomRespaldo" [options]="lisRequisitos" filter="filter"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
                       formControlName="idRespaldo" *ngIf="!edit"
          ></p-dropdown>
          <label class="falso-combo-texto" *ngIf="edit">{{ selRespaldo.nombreRespaldo }}</label>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idRespaldo.invalid">
            {{ 'REQUISITOS.LBL_REQUISITOS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>{{'REQUISITOS.LBL_TIPOVINCULACION' | translate}}:</label>
          <p-multiSelect id="idCanal" name="nomCanal" [options]="lisTipoVinculacion"
                         filter="filter"
                         defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                         selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}"
                         formControlName="idTipoVinculacion"
                         emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         optionValue="value"
                         optionLabel="label"
          ></p-multiSelect>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>{{'GARANTIASIDONEAS.LBL_PRODUCTO' | translate}}:</label>
          <p-multiSelect id="idCanal" name="nomCanal" [options]="lisProductos"
                         filter="filter"
                         defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                         selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}"
                         formControlName="idProducto"
                         emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         optionValue="value"
                         optionLabel="label"
          ></p-multiSelect>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label> {{ "FLUJOVENTACONSULTAS.LBL_OCUPACION" | translate }}</label>
          <p-multiSelect
            id="idsOcupaciones"
            name="idsOcupaciones"
            [options]="listasTiposOcupaciones"
            defaultLabel="{{ 'LBL_SELECCIONE' | translate }}"
            selectedItemsLabel="{0} {{'LBL_ELEMENTOSSELECCIONADOS' | translate}}"
            formControlName="idsOcupaciones"
            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            optionValue="value"
            optionLabel="label"
          >
          </p-multiSelect>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'FLUJOVENTA.LBL_NATURALEZA' | translate }}</label>
          <p-multiSelect id="idTipoPersona" name="nomTipoPersona" [options]="listaTiposPersonas"
                         filter="filter"
                         defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                         selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="naturaleza"
                         emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         optionValue="value"
                         optionLabel="label"
          ></p-multiSelect>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.naturaleza.invalid">
            {{ 'FLUJOVENTA.LBL_NATURALEZA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
    </div>
    <div class="grid form-group">
      <div class="col-12">
        <p-pickList [source]="actFuente" [target]="actSeleccionadas"
                    sourceHeader="{{'SEGMENTOSACTIVIDADES.LBL_ACTIVIDADESDISPONIBLES'|translate}}"
                    targetHeader="{{'SEGMENTOSACTIVIDADES.LBL_ACTIVIDADESSELECCIONADAS'|translate}}"
                    (onMoveAllToTarget)="guardar($event.items, true)"
                    (onMoveAllToSource)="guardar($event.items, false)"
                    (onMoveToTarget)="guardar($event.items, true)"
                    (onMoveToSource)="guardar($event.items, false)"
                    [showTargetControls]="false"
                    [showSourceControls]="false"
                    filterBy="actividadEconomica">
          <ng-template let-actividad pTemplate="item">
            <div class="p-helper-clearfix">
              {{actividad.codigoActividadEconomica}}-{{actividad.actividadEconomica}}
            </div>
          </ng-template>
        </p-pickList>
      </div>
    </div>
    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <button icon="fa fa-plus" *ngIf="!edit"
                label="{{'BTN_AGREGAR' | translate }}"
                type="submit"
                (click)="onSubmit()"
                pButton></button>
        <button icon="fa fa-plus" *ngIf="edit"
                label="{{'BTN_EDITAR' | translate }}"
                type="submit"
                (click)="onSubmit()"
                pButton></button>
      </div>
    </div>
  </form>


  <div class="grid">
    <div class="col-12 md:col-6 lg:col-6">
    </div>
    <div class="col-12 md:col-6 lg:col-6">
      <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
             (input)="dt.filterGlobal($event.target.value, 'contains')">
    </div>
  </div>

  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" #dt
               [value]="lisRequisitoRespaldo"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.nombreRespaldo}}</td>
            <td > {{row.tiposVinculaciones}} <span *ngIf="row.verMasTiposVinculaciones" (click)="detalleTabla(row, 'tipoVincularion')" style="cursor: pointer;">...</span></td>
            <td >{{row.productos}} <span *ngIf="row.verMasProductos" (click)="detalleTabla(row, 'producto')" style="cursor: pointer;">...</span></td>
            <td >{{row.textoNaturaleza}} <span *ngIf="row.verMasNaturaleza" (click)="detalleTabla(row, 'naturaleza')" style="cursor: pointer;">...</span></td>
            <td >{{row.textoOcupaciones}} <span *ngIf="row.verMasOcupaciones" (click)="detalleTabla(row, 'ocupaciones')" style="cursor: pointer;">...</span></td>
            <td >{{row.actividades}} <span *ngIf="row.verMasActividades" (click)="detalleTabla(row, 'actividad')" style="cursor: pointer;">...</span></td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-danger btn" icon="fa fa-pencil" data-toggle="tooltip"
                        title="{{'BTN_EDITAR' | translate}}" pButton
                        (click)="editar(row)"></button>

                <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                        title="{{'BTN_INHABILITAR' | translate}}" pButton
                        (click)="inhablitar(row)" [disabled]="edit"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>


<p-dialog id="dlgCausales"
          [draggable]="false"
          [resizable]="false"
          [closable]="true"

          *ngIf="detalle"
          [(visible)]="detalle"
          [contentStyle]="{'width':'600px', 'overflow-y': 'auto', 'max-height': '350px', 'overflow-x': 'auto'}"
          [header]="tituloDetalle"
          [modal]="true">

  <div class="grid form-group">
    <div class="col-12 md:col-12 lg:col-12">
      <div class="div-form">
        {{textoDetalle}}
      </div>
    </div>
  </div>
</p-dialog>


<p-confirmDialog #cd key="tipo-respaldo">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
